// extracted by mini-css-extract-plugin
export default {"navLink":"AppNavigation_navLink__2I27w"};